import Cookies from 'js-cookie';
import { APP_ID_KEY } from '../App/config/enums';

export function getStoredAppID(): string | null | undefined {
  return window.localStorage
    ? window.localStorage.getItem(APP_ID_KEY)
    : Cookies.get(APP_ID_KEY);
}
